import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConstantsService } from '../constant/constants.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { GenericCrudService } from '../generic-crud.service';
import { TypeEntretien } from 'src/app/shared/models/typeEntretien';

@Injectable({
	providedIn: 'root'
})
export class TypeEntretienService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllTypeEntretien(): Observable<TypeEntretien[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.typeEntretienUrl}/all`,
			'getAllTypeEntretien'
		);
	}

	importTypeEntretien(file: File): Observable<ImportResponse> {
		const formData: FormData = new FormData();
		formData.append('file', file, 'typeEntretien.csv');
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.typeEntretienUrl}/import`,
			`importTypeEntretien`,
			formData
		);
	}

	getTypeEntretienById(id: number): Observable<TypeEntretien> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.typeEntretienUrl}/get/${id}`,
			'getTypeEntretienById'
		);
	}

	updateTypeEntretien(typeEntretien: TypeEntretien): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.typeEntretienUrl}/update/${typeEntretien.id}`,
			'updateTypeEntretien',
			typeEntretien
		);
	}

	addTypeEntretien(typeEntretien: TypeEntretien): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.typeEntretienUrl}/add`,
			'addTypeEntretien',
			typeEntretien
		);
	}

	deleteTypeEntretien(typeEntretienId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.typeEntretienUrl}/delete/${typeEntretienId}`,
			`deleteTypeEntretien`
		);
	}
}
